// Slides del home en 2 tamaños:
//   l = 1920x600 (web; null = no se muestra en web)
//   s = 500x500  (mobile, hasta MOBILE_MAX; puede ser una lista; null = no se muestra en mobile)
// El orden de esta lista es el orden del carrusel.

import sponsorsWebL from "../assets/Slider/1920 x 600 px/Sponsors_Platinum_1920x600px.png";
import sancorS from "../assets/Slider/500 x 500 px/Sponsor_Sancor_500x500px.png";
import rpmS from "../assets/Slider/500 x 500 px/Sponsor_Rpm_500x500px.png";
import bigS from "../assets/Slider/500 x 500 px/Sponsor_Big_500x500px.png";
import wiltelS from "../assets/Slider/500 x 500 px/Sponsor_Wiltel_500x500px.png";
import pinguinoS from "../assets/Slider/500 x 500 px/Sponsor_Pinguino_500x500px.png";

import s01L from "../assets/Slider/1920 x 600 px/Slide01_1920x600px.png";
import s01S from "../assets/Slider/500 x 500 px/Slide01_500x500px.png";
import s03L from "../assets/Slider/1920 x 600 px/Slide03_1920x600px.png";
import s03S from "../assets/Slider/500 x 500 px/Slide03_500x500px.png";
import s05L from "../assets/Slider/1920 x 600 px/Slide05_1920x600px.png";
import s05S from "../assets/Slider/500 x 500 px/Slide05_500x500px.png";
import s06L from "../assets/Slider/1920 x 600 px/Slide06_1920x600px.jpg";
import s06S from "../assets/Slider/500 x 500 px/Slide06_500x500px.jpg";
import s07L from "../assets/Slider/1920 x 600 px/Slide07_1920x600px.jpg";
import s07SA from "../assets/Slider/500 x 500 px/Slide07_500x500px A.jpg";
import s07SB from "../assets/Slider/500 x 500 px/Slide07_500x500px B.jpg";
import s08L from "../assets/Slider/1920 x 600 px/Slide08_1920x600px.jpg";
import s08S from "../assets/Slider/500 x 500 px/Slide08_500x500px.jpg";
import s09L from "../assets/Slider/1920 x 600 px/Slide09_1920x600px.png";
import s09S from "../assets/Slider/500 x 500 px/Slide09_500x500px.png";
import s10L from "../assets/Slider/1920 x 600 px/Slide10_1920x600px.jpg";
import s10S from "../assets/Slider/500 x 500 px/Slide10_500x500px.jpg";

export const MOBILE_MAX = 768;

export const TICKETERA_LINK = "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga";
const IG = "https://www.instagram.com/tera.oficial.ok";

const SLIDES = [
  { l: s10L, s: s10S },
  // Web: una sola placa con todas las marcas platinum.
  { l: sponsorsWebL, s: null },
  // Mobile: una placa por marca.
  { l: null, s: wiltelS },
  { l: null, s: rpmS },
  { l: null, s: sancorS },
  { l: null, s: bigS },
  { l: null, s: pinguinoS },
  { l: s01L, s: s01S },
  { l: s03L, s: s03S, href: IG },
  { l: s05L, s: s05S, href: TICKETERA_LINK },
  { l: s06L, s: s06S, href: TICKETERA_LINK },
  { l: s07L, s: [s07SA, s07SB] },
  { l: s08L, s: s08S },
  { l: s09L, s: s09S },
];

export function pickSlides(width) {
  const mobile = width <= MOBILE_MAX;
  return SLIDES.flatMap(({ l, s, href }) =>
    [].concat(mobile ? s : l).filter(Boolean).map((src) => ({ src, href })),
  );
}
